import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=4150f267&scoped=true&"
import script from "./SettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./SettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsDialog.vue?vue&type=style&index=0&id=4150f267&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150f267",
  null
  
)

export default component.exports